export { makeAnalyticsEvent } from './make-analytics-event';
export * from './analytics-event.d';
